import { FormattedMessage } from 'react-intl';
import { ReactNode } from 'react';

import { PoolSelect } from '../../select';
import { useFilter } from '../context';

enum BonusCustomerFilterValues {
    AllCustomers = 'ALL_CUSTOMERS',
    Finished = 'true',
    NotFinished = 'false',
}

export const BonusCustomerFilter = () => {
    const { filter, updateFilter, registerFilterMap } = useFilter();

    const onSelected = (bonusCustomer?: BonusCustomerFilterValues) => {
        filter.delete('isFinished');
        if (bonusCustomer) {
            filter.set('isFinished', bonusCustomer);
        }
        updateFilter(filter);
    };

    const getDisplayValue = (bonusCustomerValue: unknown): ReactNode => {
        if (typeof bonusCustomerValue !== 'string') {
            return '';
        }

        const bonusCustomer = bonusCustomerValue as BonusCustomerFilterValues;
        return <FormattedMessage id="app.select.bonusCustomer" values={{ bonusCustomer }} />;
    };

    registerFilterMap('isFinished', getDisplayValue);

    return (
        <PoolSelect
            disallowDefaultValue={true}
            name="status"
            label={<FormattedMessage id="app.filter.bonusCustomerLabel" />}
            fullWidth={true}
            value={filter.get('isFinished')}
            onValueChange={onSelected}
            noSorting={true}
            options={Object.values(BonusCustomerFilterValues).map(bonusCustomer => {
                return {
                    value: bonusCustomer,
                    displayValue: <FormattedMessage id="app.select.bonusCustomer" values={{ bonusCustomer }} />,
                };
            })}
        />
    );
};
